import { INIT_STACKUP_DATA, CHANGE_STACKUP_TABLE, SETTING_UNIT } from './actionTypes';

export const saveData = (data, unit) => ({
  type: INIT_STACKUP_DATA,
  data,
  unit,
})

export const changeStackupTable = (data, unit) => ({
  type: CHANGE_STACKUP_TABLE,
  data,
  unit
})

export const settingUnit = (unit) => ({
  type: SETTING_UNIT,
  unit
})